import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const INLINE = /(\*\*[^*]+\*\*|\[[^\]]+\]\(\/[^)\s]*\))/g;

const Inline = ({ text, onLink }) => text.split(INLINE).map((part, i) => {
  const b = part.match(/^\*\*([^*]+)\*\*$/);
  if (b) return <strong key={i} className="font-semibold text-zinc-900">{b[1]}</strong>;
  const l = part.match(/^\[([^\]]+)\]\((\/[^)\s]*)\)$/);
  if (l) {
    return (
      <button key={i} type="button" onClick={() => onLink(l[2])} data-testid={`assistant-link-${l[2].replace(/\W/g, "") || "home"}`}
        className="inline-flex items-center gap-0.5 rounded-md bg-emerald-50 px-1.5 py-0.5 text-[13px] font-medium text-emerald-800 ring-1 ring-emerald-200 hover:bg-emerald-100 transition-colors">
        {l[1]}<ArrowUpRight className="h-3 w-3" />
      </button>
    );
  }
  return <Fragment key={i}>{part}</Fragment>;
});

// Asistan cevabı için küçük markdown: kalın, iç bağlantı, liste ve paragraflar.
export const AssistantText = ({ text }) => {
  const navigate = useNavigate();
  const lines = (text || "").replace(/\[\[DESTEK\]\]/g, "").split("\n");
  return (
    <div className="space-y-1.5 text-sm leading-relaxed text-zinc-700">
      {lines.map((ln, i) => {
        const t = ln.trim();
        if (!t) return null;
        const li = t.match(/^(\d+\.|[-•*])\s+(.*)$/);
        if (li) {
          return (
            <div key={i} className="flex gap-2">
              <span className="shrink-0 text-emerald-700 font-semibold tabular">{/\d/.test(li[1]) ? li[1] : "•"}</span>
              <span><Inline text={li[2]} onLink={navigate} /></span>
            </div>
          );
        }
        const h = t.match(/^#+\s+(.*)$/);
        if (h) return <p key={i} className="font-semibold text-zinc-900">{h[1]}</p>;
        return <p key={i}><Inline text={t} onLink={navigate} /></p>;
      })}
    </div>
  );
};
